export var HotelBrand = function (HotelBrand) {
  HotelBrand["PI"] = "PI";
  HotelBrand["HUB"] = "HUB";
  HotelBrand["ZIP"] = "ZIP";
  HotelBrand["PID"] = "PID";
  return HotelBrand;
}({});